import StaffListVerticalTab from "../../../components/business/staff/staffListVerticalTab";
import Portal from "../portal"; 
const StaffPortal = (props: any) => {
  return <Portal TabComponent={StaffListVerticalTab} title ={"Team members"} props= {props} />;
};
export default StaffPortal;
